import { FC } from 'react';
import { useObservable } from '@streem/sdk-react';
import { observer } from 'mobx-react';
import { useDetailSession } from '../../hooks/detail_session_hooks';
import { useGlobalStore } from '../../hooks/use_global_context';
import { CallDetailsToolbar } from './call_details_toolbar';
import { CallDetailsWithTabs } from './tabs/call_detail_with_tabs';
import { CallDetailNoTab } from './reservation/call_detail_no_tab';
import { LegacyCallDetailContent } from './legacy/call_detail_content';
import { BodyStyles } from './body_styles';
import { useReadOnly } from '../../hooks/use_read_only';

/**
 * Call Details page UI
 */
export const CallDetailsView: FC = observer(() => {
    const detailSession = useDetailSession();
    const { companySettingsStore } = useGlobalStore();
    const [room] = useObservable(detailSession.room.room);
    const { readOnlyYn } = useReadOnly();

    // There are 3 views now:
    //
    // 1. When call details are enabled and tabs are enabled, show the tabbed call details view
    // 2. When call details are enabled and tabs are disabled, show the call details view
    // 3. When call details are disabled, show the legacy call details view
    //
    // Note: if there are no call details for this call/room, the legacy call details view
    //    will be shown
    const showCallDetailsYn =
        companySettingsStore.ahsVirtualExpertEnabled && room?.callDetail != null;
    const showTabbedCallDetailsYn = showCallDetailsYn && companySettingsStore.callDetailTabsEnabled;

    const renderContents = () => {
        if (!room) return null;

        if (showTabbedCallDetailsYn) {
            return <CallDetailsWithTabs readOnly={readOnlyYn} />;
        }
        if (showCallDetailsYn) {
            return <CallDetailNoTab readOnly={readOnlyYn} />;
        }
        return <LegacyCallDetailContent readOnly={readOnlyYn} />;
    };

    return (
        <div style={{ width: '100%', overflowY: 'scroll' }} key={detailSession.roomId.toString()}>
            <BodyStyles />
            <CallDetailsToolbar room={room} />
            {renderContents()}
        </div>
    );
});
